import script from "./PrestVariantDefault.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrestVariantDefault.vue?vue&type=script&lang=ts&setup=true"

import "./PrestVariantDefault.vue?vue&type=style&index=0&id=0f6928ec&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f6928ec"]])

export default __exports__